/**
 * Nocturne status palette + presentation helpers shared across the SPA.
 * Colors match the Claude Design prototype exactly.
 */
export const OK = "#63b98c";
export const WARN = "#d3a24a";
export const CRIT = "#d76b6b";
export const UNK = "#75798c";
export const ACC = "#968ae0";

/** Map any coarse status string to a status color. */
export function statusColor(st: string): string {
  if (st === "Ready" || st === "Success" || st === "Healthy" || st === "Valid" || st === "Up" || st === "ok")
    return OK;
  if (
    st === "Degraded" ||
    st === "Failed" ||
    st === "Renewal failed" ||
    st === "critical" ||
    st === "crit"
  )
    return CRIT;
  if (
    st === "Expiring" ||
    st === "Paused" ||
    st === "warning" ||
    st === "warn" ||
    st === "Challenge failing"
  )
    return WARN;
  return UNK;
}

/** Gauge fill color by percentage (null => unknown/not scraped). */
export function gaugeColor(v: number | null): string {
  return v == null ? UNK : v >= 85 ? CRIT : v >= 70 ? WARN : OK;
}

/** Days-to-expiry color for the certificate radar. */
export function expiryColor(d: number | null): string {
  return d == null ? UNK : d < 0 ? CRIT : d < 14 ? CRIT : d < 30 ? WARN : OK;
}

export function expiryText(d: number | null): string {
  return d == null ? "unknown" : d < 0 ? `expired ${Math.abs(d)}d ago` : `in ${d}d`;
}
